import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon, ShieldIcon, LockIcon, UserIcon, ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ColorComparisonPage() {
  return <div className="w-full bg-[#f8f8f8]" data-id="element-867" data-mp="15uz1ag5fa2l1">
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-868" data-mp="1as8t22gaaqc1">
        <Link to="/" className="flex items-center text-gray-600 hover:text-[#214ae9] transition-colors font-medium" data-id="element-869" data-mp="1auuxht7vopq1">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-870" data-mp="23hpeuh9ef8za" />
          <span data-id="element-871" data-mp="23jilhwk0ht7a">Go Back</span>
        </Link>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-16" data-id="element-872" data-mp="1ori6wvh0p8cu">
        <div className="text-center mb-12" data-id="element-873" data-mp="1oqp588wx191k">
          <h1 className="text-4xl md:text-5xl font-bold text-[#111111] mb-4" data-id="element-874" data-mp="1tql0njrjrs5i">
            Color Strategy Options
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-875" data-mp="2hfw4ja4722nv">
            Explore different approaches to using your brand colors. Each option
            shows a unique hierarchy and emphasis.
          </p>
        </div>

        <div className="space-y-16" data-id="element-876" data-mp="3sxns5lw9dz1">
          {/* Option 1: Blue Primary (Current) */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-877" data-mp="3uzi9rax3dvp7">
            <div className="bg-[#1a0647] px-8 py-4 border-b border-gray-700" data-id="element-878" data-mp="cppzakcuc6ra">
              <h2 className="text-xl font-bold text-white" data-id="element-879" data-mp="7vc0e7yyzhhv">
                Option 1: Blue Primary
              </h2>
              <p className="text-sm text-gray-300" data-id="element-880" data-mp="mnw0ezqtp8v3">
                Professional and trustworthy • Current implementation
              </p>
            </div>
            <div className="p-8" data-id="element-881" data-mp="vlg74o7gfxd3">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-882" data-mp="vkdfuf67zswn">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-883" data-mp="rj1n40s1urk8">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-884" data-mp="2xem7rxihz52d">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-885" data-mp="11apva0zf29gb">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-886" data-mp="168zrmewvng3i">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-887" data-mp="1f9pkb9qucqd0">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-lg flex items-center space-x-2" data-id="element-888" data-mp="1k9ak1mdu52qs">
                      <span data-id="element-889" data-mp="1p2dd7tepaa6g">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-890" data-mp="1tzn0p3ij4brn" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-891" data-mp="1yyq6wra8wo17">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-892" data-mp="3jfzd29v5zhij">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-893" data-mp="3jf7h2xxnnhrq">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-894" data-mp="3ehxvxuhats9p">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-895" data-mp="39kfmm2zddb16" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-896" data-mp="b2s2xrbzmfi4">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-897" data-mp="1a48v4ce6pn3">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-898" data-mp="3sfcnp5v0yc4u">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-899" data-mp="tt9vnvwtlb3h">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-900" data-mp="9ip4qx4li5z3" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-901" data-mp="dk2cjcr90j8n">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-902" data-mp="3vqp2709wlsgn">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 2: Purple Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-903" data-mp="x81k6eqina9u">
            <div className="bg-[#b063ff] px-8 py-4 border-b border-purple-400" data-id="element-904" data-mp="ij59e9x2rj5j">
              <h2 className="text-xl font-bold text-white" data-id="element-905" data-mp="ihavhfk80ray">
                Option 2: Purple Primary
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-906" data-mp="1b82oy59wj1ul">
                Modern and energetic • Bold personality
              </p>
            </div>
            <div className="p-8" data-id="element-907" data-mp="1g03yvkjlkghg">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-908" data-mp="30oy5zqn6ezhk">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-909" data-mp="2vq3dfwzepwk9">
                  <div className="inline-block bg-[#00f4f8] bg-opacity-20 text-[#00f4f8] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#00f4f8] border-opacity-30" data-id="element-910" data-mp="2vplcwo5pow6j">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-911" data-mp="2hpk84xmbt4ls">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-912" data-mp="2csttmeq66h2h">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-913" data-mp="2lts0r5vwn4pa">
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg flex items-center space-x-2" data-id="element-914" data-mp="5zq9j3u1c3zz">
                      <span data-id="element-915" data-mp="2uteo381xa3xr">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-916" data-mp="2usmuu3vssian" />
                    </button>
                    <button className="border-2 border-[#214ae9] text-[#214ae9] px-6 py-3 rounded-lg font-bold hover:bg-[#214ae9] hover:text-white transition-all" data-id="element-917" data-mp="2zrpzhn7v8mi3">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-918" data-mp="2c3yb3l91wj0g">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-919" data-mp="2c13s7y5or695">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-920" data-mp="2g4s42t1coo07">
                      <ShieldIcon className="w-6 h-6 text-[#b063ff]" data-id="element-921" data-mp="2publdu9f09sy" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-922" data-mp="1sexpo71durdu">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-923" data-mp="1xcps3uznlvwa">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-924" data-mp="1kvogoewsgupb">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-925" data-mp="1fwbttu5x3nmq">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-926" data-mp="1bv9vdfjtrflt" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-927" data-mp="16w5l0ll5zbtw">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-928" data-mp="123cf3udylxg8">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 3: Cyan Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-929" data-mp="o5nt2j85ok9l">
            <div className="bg-[#00f4f8] px-8 py-4 border-b border-cyan-300" data-id="element-930" data-mp="j5jdqwizhvky">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-931" data-mp="272r4yipuebpk">
                Option 3: Cyan Primary
              </h2>
              <p className="text-sm text-[#111111] text-opacity-70" data-id="element-932" data-mp="2c2dh0otxplws">
                Fresh and innovative • High energy
              </p>
            </div>
            <div className="p-8" data-id="element-933" data-mp="1y45f02i1juer">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-934" data-mp="2234toetkr5je">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-935" data-mp="1obzpr0j6br39">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-936" data-mp="1oag753a1p3yb">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-937" data-mp="1jcenoh8pj2mb">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-938" data-mp="15frhroys1249">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-939" data-mp="qsjagz8l9gxk">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-[#00d9dd] transition-all shadow-lg flex items-center space-x-2" data-id="element-940" data-mp="lswxmqwoa2pa">
                      <span data-id="element-941" data-mp="vp9ozi4qw4gv">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-942" data-mp="vohvqdymeitr" />
                    </button>
                    <button className="border-2 border-[#b063ff] text-[#b063ff] px-6 py-3 rounded-lg font-bold hover:bg-[#b063ff] hover:text-white transition-all" data-id="element-943" data-mp="19o9f6u7worf5">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-944" data-mp="1egsrzoyrriiw">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-945" data-mp="1sfsi711xk5h6">
                    <div className="w-12 h-12 bg-[#00f4f8] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-946" data-mp="1sdpljy69ve3h">
                      <ShieldIcon className="w-6 h-6 text-[#00f4f8]" data-id="element-947" data-mp="761xmc73702c" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-948" data-mp="2ea4btwjqg8i">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-949" data-mp="3tle8mh1b3od8">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-950" data-mp="q4nzvuecax7u">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-951" data-mp="l4ruprtwozqp">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-952" data-mp="g56qp2zvq174" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-953" data-mp="b63pjtn0sf4f">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-954" data-mp="30ucos2mo54nd">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 4: Balanced Trio */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-955" data-mp="1gfg8rkhnvru6">
            <div className="bg-gradient-to-r from-[#214ae9] via-[#b063ff] to-[#00f4f8] px-8 py-4" data-id="element-956" data-mp="1lcgefualmskr">
              <h2 className="text-xl font-bold text-white" data-id="element-957" data-mp="1q59i0eubzuv9">
                Option 4: Balanced Trio
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-958" data-mp="1v2rnfv953ryi">
                Equal emphasis • Vibrant and dynamic
              </p>
            </div>
            <div className="p-8" data-id="element-959" data-mp="243hdsjfmsq4u">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-960" data-mp="245aiht6op0a7">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-961" data-mp="292k93c5t7hzm">
                  <div className="inline-block bg-white bg-opacity-10 text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-white border-opacity-20" data-id="element-962" data-mp="9qribx9m78vc">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-963" data-mp="6ovdllo58i29">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-964" data-mp="gm9luxzwy0jh">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-965" data-mp="pmpjvrxw0fgy">
                    <button className="bg-gradient-to-r from-[#214ae9] to-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:shadow-xl transition-all shadow-lg flex items-center space-x-2" data-id="element-966" data-mp="pl4pc2bkowj3">
                      <span data-id="element-967" data-mp="zc97fawjoxi5">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-968" data-mp="udfr7apvisea" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-969" data-mp="19b83zv41d2os">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-970" data-mp="1rz8wmcgdej84">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-971" data-mp="1ryz3ig013vy7">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-972" data-mp="1dyy28zfuqmi7">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-973" data-mp="1ix9efgtmd93l" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-974" data-mp="148d6djrkbw2z">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-975" data-mp="v985i6sj3qnn">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-976" data-mp="108kv2zasbbtx">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-977" data-mp="lblpfgzhtt23">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-978" data-mp="q9dfe5gkv53n" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-979" data-mp="1tkj3xxmfeeb4">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-980" data-mp="1jv9dsnb575pn">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 5: High Contrast */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-981" data-mp="19yeieda61lfl">
            <div className="bg-[#111111] px-8 py-4 border-b border-gray-800" data-id="element-982" data-mp="15u6q664i1ncm">
              <h2 className="text-xl font-bold text-white" data-id="element-983" data-mp="10x6khwbkamm1">
                Option 5: High Contrast
              </h2>
              <p className="text-sm text-gray-400" data-id="element-984" data-mp="vz51fbe4ynak">
                Bold and striking • Maximum impact
              </p>
            </div>
            <div className="p-8" data-id="element-985" data-mp="2qbl4k3bmxlb7">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-986" data-mp="2qcd23joslt44">
                {/* Hero preview */}
                <div className="bg-[#111111] rounded-xl p-8 border-2 border-[#00f4f8]" data-id="element-987" data-mp="2xu2v7mbn7gre">
                  <div className="inline-block bg-[#00f4f8] text-[#111111] px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-988" data-mp="32svxsjpe5ncs">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-989" data-mp="3ck0b7ezf505i">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-990" data-mp="2ey3042ndbx3l">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-991" data-mp="2ow90ugxfux6v">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-white transition-all shadow-lg flex items-center space-x-2" data-id="element-992" data-mp="2tuafmpnu0acj">
                      <span data-id="element-993" data-mp="92rwh3zzmgf0">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-994" data-mp="91gr4zqw90ls" />
                    </button>
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg" data-id="element-995" data-mp="2553ok3qgx9gx">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-996" data-mp="2a4q3qipuwzsd">
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-997" data-mp="2a61386c9rldo">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-998" data-mp="1mg6qrpvv3yty">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-999" data-mp="1hif0t1es2mse" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-1000" data-mp="1v9a29smy61ly">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-1001" data-mp="12rfy270misgq">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-1002" data-mp="ypuey3xhxhy3">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-1003" data-mp="okuqikg9aosx">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-1004" data-mp="teyxv4tfoyuj" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-1005" data-mp="ept07la8vgor">
                      Easy to Use
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-1006" data-mp="17cniqcni45zl">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 6: Light & Airy */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-1007" data-mp="xe7r88kkaupk">
            <div className="bg-white px-8 py-4 border-b-2 border-[#214ae9]" data-id="element-1008" data-mp="12bpr79glpzlf">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-1009" data-mp="3i3x5ajdfych7">
                Option 6: Light & Airy
              </h2>
              <p className="text-sm text-gray-600" data-id="element-1010" data-mp="3n52z6kiu85sb">
                Minimal and clean • Approachable
              </p>
            </div>
            <div className="p-8" data-id="element-1011" data-mp="2zefi58p257kv">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1012" data-mp="2zd4cf3c1xpr4">
                {/* Hero preview */}
                <div className="bg-white rounded-xl p-8 border-2 border-gray-200" data-id="element-1013" data-mp="2ufuipbhmqrxh">
                  <div className="inline-block bg-[#214ae9] bg-opacity-5 text-[#214ae9] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#214ae9] border-opacity-20" data-id="element-1014" data-mp="2qej03px6b6ys">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-[#111111] mb-4" data-id="element-1015" data-mp="3i6qf6lx16bb2">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-1016" data-mp="39bafvpdib3y3">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-1017" data-mp="4x2i3cie50z5">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-md flex items-center space-x-2" data-id="element-1018" data-mp="1nkvd5966bry4">
                      <span data-id="element-1019" data-mp="1sk886h7785bs">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-1020" data-mp="1wl1y1g47bu7b" />
                    </button>
                    <button className="bg-white border-2 border-gray-300 text-[#111111] px-6 py-3 rounded-lg font-bold hover:border-[#214ae9] hover:text-[#214ae9] transition-all" data-id="element-1021" data-mp="21kmwzqjdg2k1">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-1022" data-mp="2g90z1z8yrmzj">
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#214ae9] transition-colors" data-id="element-1023" data-mp="2gacckqs7o93u">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-1024" data-mp="2kcz0iglrh9vr">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-1025" data-mp="2u8sk2jxwe3n1" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-1026" data-mp="2jbtrm4v8j1ut">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-1027" data-mp="2ndf8e1aw40aa">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#b063ff] transition-colors" data-id="element-1028" data-mp="2xbcykucb875j">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-1029" data-mp="329o977afilot">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-1030" data-mp="369olala22ksp" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-1031" data-mp="3b4kq6m0e52n8">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-1032" data-mp="3l0xjhis0xehg">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 6 Expanded: Core Purple Lead */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-1033" data-mp="1ea2chaejvus2">
            <div className="bg-white px-8 py-4 border-b-2 border-[#631bb7]" data-id="element-1034" data-mp="19fom5meqwdu9">
              <h2 className="text-xl font-bold text-[#1a0647]" data-id="element-1035" data-mp="14ehdll4s3amj">
                Option 6 Expanded: Light & Airy, Core Purple Lead
              </h2>
              <p className="text-sm text-gray-600" data-id="element-1036" data-mp="1x3fwikgq6gsw">
                Deep dive • Showing how to use #631bb7 with restraint
              </p>
            </div>
            <div className="p-8 space-y-12" data-id="element-1037" data-mp="1s5wkzsbewi4n">
              {/* 1. Hero Preview */}
              <div data-id="element-1038" data-mp="1nbiil5yc1aqh">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1039" data-mp="1naqoy0oapn2u">
                  1. Hero Surface
                </h3>
                <div className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm relative overflow-hidden" data-id="element-1040" data-mp="2fufrq3etcmum">
                  {/* Subtle background wash */}
                  <div className="absolute inset-0 bg-[#631bb7] opacity-[0.02] pointer-events-none" data-id="element-1041" data-mp="95du3i3c81gx"></div>

                  <div className="relative z-10" data-id="element-1042" data-mp="e4qezxaneygv">
                    <div className="inline-block bg-[#631bb7] bg-opacity-[0.06] text-[#631bb7] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#631bb7] border-opacity-20" data-id="element-1043" data-mp="e3fatwdajop8">
                      🚀 New Feature
                    </div>
                    <h3 className="text-3xl md:text-4xl font-bold text-[#1a0647] mb-4 tracking-tight" data-id="element-1044" data-mp="3mjijo5g53jf5">
                      Protect your family from digital chaos
                    </h3>
                    <p className="text-gray-600 mb-8 max-w-xl text-lg" data-id="element-1045" data-mp="3cm440821iynw">
                      Take control of your family's digital security with our
                      comprehensive protection tools. Simple, guided, and
                      effective.
                    </p>
                    <div className="flex flex-wrap gap-4" data-id="element-1046" data-mp="1aso92yyx6xn4">
                      <button className="bg-[#631bb7] text-white px-7 py-3.5 rounded-lg font-semibold hover:bg-[#501594] transition-all shadow-sm flex items-center space-x-2" data-id="element-1047" data-mp="1ft2a3x23t7bn">
                        <span data-id="element-1048" data-mp="2vdbdbdlgze63">Get Started</span>
                        <ArrowRightIcon size={18} data-id="element-1049" data-mp="2vafeln1sslgl" />
                      </button>
                      <button className="bg-white border-2 border-gray-200 text-[#1a0647] px-7 py-3.5 rounded-lg font-semibold hover:border-[#631bb7] hover:text-[#631bb7] transition-all" data-id="element-1050" data-mp="3a2qyme28eree">
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* 2. Button Spectrum */}
              <div data-id="element-1051" data-mp="3syz9bxe0juh3">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1052" data-mp="3szioj6ca44rf">
                  2. Button Hierarchy
                </h3>
                <div className="bg-white rounded-xl p-8 border border-gray-200 flex flex-wrap items-center gap-6" data-id="element-1053" data-mp="1ylhio1ibahhu">
                  <button className="bg-[#631bb7] text-white px-6 py-2.5 rounded-md font-medium hover:bg-[#501594] transition-colors shadow-sm" data-id="element-1054" data-mp="1tohl6ezj2n2c">
                    Primary Action
                  </button>
                  <button className="bg-white border border-[#631bb7] text-[#631bb7] px-6 py-2.5 rounded-md font-medium hover:bg-[#631bb7] hover:bg-opacity-5 transition-colors" data-id="element-1055" data-mp="pnrdvxa9mqdi">
                    Secondary Outline
                  </button>
                  <button className="text-[#631bb7] px-4 py-2.5 rounded-md font-medium hover:bg-[#631bb7] hover:bg-opacity-5 transition-colors" data-id="element-1056" data-mp="1zqd5ajbwe8n">
                    Ghost Button
                  </button>
                  <div className="h-8 w-px bg-gray-200 mx-2" data-id="element-1057" data-mp="b0oh5strolr8"></div>
                  <button className="bg-[#01ced1] text-[#1a0647] px-5 py-2 rounded-full text-sm font-bold hover:bg-[#00b8b8] transition-colors shadow-sm" data-id="element-1058" data-mp="az4wzr4zpqk6">
                    Accent / Special
                  </button>
                </div>
              </div>

              {/* 3. Feature Cards */}
              <div data-id="element-1059" data-mp="3jeevkp9o8dn7">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1060" data-mp="3bwqj2sayc9z6">
                  3. Interactive Cards
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1061" data-mp="36y5igrrsfoa7">
                  <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#631bb7] hover:shadow-md transition-all cursor-pointer group" data-id="element-1062" data-mp="32v95bgl0okdn">
                    <div className="w-12 h-12 bg-[#631bb7] bg-opacity-[0.06] rounded-xl flex items-center justify-center mb-5 group-hover:bg-opacity-10 transition-all" data-id="element-1063" data-mp="2xza9x919u23q">
                      <ShieldIcon className="w-6 h-6 text-[#631bb7]" data-id="element-1064" data-mp="2o5l6qn47zztm" />
                    </div>
                    <h4 className="text-lg font-semibold text-[#1a0647] mb-2" data-id="element-1065" data-mp="2j8kws1492cx8">
                      Bank-Level Security
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1066" data-mp="2a73kyuxvkxec">
                      Enterprise-grade protection scaled for your family's
                      everyday needs.
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#631bb7] hover:shadow-md transition-all cursor-pointer group" data-id="element-1067" data-mp="1vjmphh646kh5">
                    <div className="w-12 h-12 bg-[#631bb7] bg-opacity-[0.06] rounded-xl flex items-center justify-center mb-5 group-hover:bg-opacity-10 transition-all" data-id="element-1068" data-mp="1lmi3pig6kr0v">
                      <LockIcon className="w-6 h-6 text-[#631bb7]" data-id="element-1069" data-mp="1qltl8todg0ji" />
                    </div>
                    <h4 className="text-lg font-semibold text-[#1a0647] mb-2" data-id="element-1070" data-mp="2ebxov11k80ai">
                      Privacy First
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1071" data-mp="24lm82dws1wm7">
                      Your data stays yours. We never sell or share your
                      personal information.
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#631bb7] hover:shadow-md transition-all cursor-pointer group" data-id="element-1072" data-mp="2x98avjy6kx80">
                    <div className="w-12 h-12 bg-[#631bb7] bg-opacity-[0.06] rounded-xl flex items-center justify-center mb-5 group-hover:bg-opacity-10 transition-all" data-id="element-1073" data-mp="qlhr5r9v6zz5">
                      <UserIcon className="w-6 h-6 text-[#631bb7]" data-id="element-1074" data-mp="lkkaxk8f0g0a" />
                    </div>
                    <h4 className="text-lg font-semibold text-[#1a0647] mb-2" data-id="element-1075" data-mp="10argx0h8k6k3">
                      Family Managed
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1076" data-mp="7mneqoxvibm5">
                      One dashboard to monitor and protect everyone you care
                      about.
                    </p>
                  </div>
                </div>
              </div>

              {/* 4. Soft Surface */}
              <div data-id="element-1077" data-mp="clgpi9lrzoim">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1078" data-mp="ckxab0nife8a">
                  4. Soft Section Fill
                </h3>
                <div className="bg-[#631bb7] bg-opacity-[0.04] rounded-2xl p-10 border border-[#631bb7] border-opacity-10 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-1079" data-mp="1o15aivfgydgs">
                  <div data-id="element-1080" data-mp="3hi1bui2ixgiq">
                    <h4 className="text-2xl font-bold text-[#1a0647] mb-3" data-id="element-1081" data-mp="3mifka181esha">
                      Ready to secure your family?
                    </h4>
                    <p className="text-gray-600 max-w-md" data-id="element-1082" data-mp="3rgqw2hhw7d25">
                      Join thousands of families who sleep better knowing their
                      digital lives are protected by Caveo.
                    </p>
                  </div>
                  <a href="#" className="inline-flex items-center gap-2 text-[#631bb7] font-semibold hover:text-[#501594] transition-colors whitespace-nowrap" data-id="element-1083" data-mp="93j98vvcqt6i">
                    View pricing plans <ChevronRightIcon size={18} data-id="element-1084" data-mp="j1qbe8kzf6og" />
                  </a>
                </div>
              </div>

              {/* 5. Usage Legend */}
              <div data-id="element-1085" data-mp="2ktbs0m7c6du4">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1086" data-mp="2kstp56q651d8">
                  5. Usage Rules (Restraint)
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1087" data-mp="x7sb579ey2by">
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-1088" data-mp="x6h9bczj34nh">
                    <h4 className="font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-1089" data-mp="t6ovakrd86aq">
                      <CheckIcon size={18} className="text-green-600" data-id="element-1090" data-mp="o8dj43dlljpc" /> Where
                      to use Purple
                    </h4>
                    <ul className="space-y-3 text-sm text-gray-600" data-id="element-1091" data-mp="1kv0f9lv3v5ce">
                      <li className="flex items-start gap-2" data-id="element-1092" data-mp="1gw9ff6z999ll">
                        <div className="w-4 h-4 rounded-full bg-[#631bb7] shrink-0 mt-0.5" data-id="element-1093" data-mp="1bvviol33tm2v"></div>
                        <span data-id="element-1094" data-mp="16y3il3sb2tnl">
                          <strong data-id="element-1095" data-mp="16x22gkwfngz0">Primary Actions:</strong> Main CTAs and
                          important buttons
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1096" data-mp="3rnjbc4b34sfv">
                        <div className="w-4 h-4 rounded-full bg-[#631bb7] bg-opacity-20 border border-[#631bb7] shrink-0 mt-0.5" data-id="element-1097" data-mp="2pw6828vyt803"></div>
                        <span data-id="element-1098" data-mp="2kxv0k4t579l1">
                          <strong data-id="element-1099" data-mp="2kyms94jmcn61">Interactive States:</strong> Hover borders,
                          active tabs, selected items
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1100" data-mp="2twyk19w81r02">
                        <div className="w-4 h-4 rounded-full bg-[#631bb7] bg-opacity-10 shrink-0 mt-0.5" data-id="element-1101" data-mp="38m4r1k1awlii"></div>
                        <span data-id="element-1102" data-mp="33ocolw315h02">
                          <strong data-id="element-1103" data-mp="33n1ihpm43x5s">Icon Fills & Badges:</strong> 5-10% opacity
                          washes for visual interest
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-1104" data-mp="1n9bf6l2thcx7">
                    <h4 className="font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-1105" data-mp="1nbe4t402541e">
                      <div className="w-4 h-4 rounded-full border-2 border-red-500 flex items-center justify-center" data-id="element-1106" data-mp="1j9svttqn99wh">
                        <div className="w-2 h-0.5 bg-red-500 rotate-45" data-id="element-1107" data-mp="1d5d4jdtz9kdg"></div>
                      </div>
                      Where NOT to use Purple
                    </h4>
                    <ul className="space-y-3 text-sm text-gray-600" data-id="element-1108" data-mp="zdpywne5azi0">
                      <li className="flex items-start gap-2" data-id="element-1109" data-mp="14brqxxtju95m">
                        <div className="w-4 h-4 rounded border border-gray-300 shrink-0 mt-0.5" data-id="element-1110" data-mp="pg1z3j1on1sz"></div>
                        <span data-id="element-1111" data-mp="uen4rxzpedot">
                          <strong data-id="element-1112" data-mp="ufodvwx5sq3w">Structural Borders:</strong> Keep standard
                          borders gray-200
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1113" data-mp="ldowh3i8fk0f">
                        <div className="w-4 h-4 rounded bg-[#1a0647] shrink-0 mt-0.5" data-id="element-1114" data-mp="lg1ne65yx4pm"></div>
                        <span data-id="element-1115" data-mp="2ar23x1ln5o5r">
                          <strong data-id="element-1116" data-mp="2fry69aqch292">Typography:</strong> Use Dark Purple (#1a0647)
                          or Gray-600 for text
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1117" data-mp="29bzei5j4nira">
                        <div className="w-4 h-4 rounded bg-white border border-gray-200 shrink-0 mt-0.5" data-id="element-1118" data-mp="29ael4j8ju5v0"></div>
                        <span data-id="element-1119" data-mp="24d4x980t629a">
                          <strong data-id="element-1120" data-mp="1zds3e3birux7">Heavy Backgrounds:</strong> Avoid large solid
                          purple panels; keep it airy
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 6 Refined: Blue Lead, Purple Accent */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-1121" data-mp="2n9nzreh3wrwv">
            <div className="bg-white px-8 py-4 border-b-2 border-[#214ae9]" data-id="element-1122" data-mp="2iajrqr5x5084">
              <h2 className="text-xl font-bold text-[#1a0647]" data-id="element-1123" data-mp="3fstinuyeyt7z">
                Option 6 Refined: Blue Lead, Purple Accent
              </h2>
              <p className="text-sm text-gray-600" data-id="element-1124" data-mp="3ichk4o9rv986">
                Light & Airy • Blue (#214ae9) for primary actions, purple
                (#631bb7) as the accent — no cyan
              </p>
            </div>
            <div className="p-8 space-y-12" data-id="element-1125" data-mp="3saxa2nx2ccg3">
              {/* 1. Hero Preview */}
              <div data-id="element-1126" data-mp="3sd089v8ddbvw">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1127" data-mp="14vvw6hsx2q8">
                  1. Hero Surface
                </h3>
                <div className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm relative overflow-hidden" data-id="element-1128" data-mp="55o8n9pvtpr9">
                  {/* Subtle purple accent wash */}
                  <div className="absolute inset-0 bg-[#631bb7] opacity-[0.02] pointer-events-none" data-id="element-1129" data-mp="ewslo3vzz0jg"></div>

                  <div className="relative z-10" data-id="element-1130" data-mp="jtj1cq3w3u4c">
                    {/* Purple accent badge */}
                    <div className="inline-block bg-[#631bb7] bg-opacity-[0.06] text-[#631bb7] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#631bb7] border-opacity-20" data-id="element-1131" data-mp="ov8bm3jag3rd">
                      🚀 New Feature
                    </div>
                    <h3 className="text-3xl md:text-4xl font-bold text-[#1a0647] mb-4 tracking-tight" data-id="element-1132" data-mp="1llbyhp2cg6nb">
                      Protect your family from digital chaos
                    </h3>
                    <p className="text-gray-600 mb-8 max-w-xl text-lg" data-id="element-1133" data-mp="1zejqhhuc745j">
                      Take control of your family's digital security with our
                      comprehensive protection tools. Simple, guided, and
                      effective.
                    </p>
                    <div className="flex flex-wrap gap-4" data-id="element-1134" data-mp="12oj23jxvqpor">
                      {/* Blue primary action */}
                      <button className="bg-[#214ae9] text-white px-7 py-3.5 rounded-lg font-semibold hover:bg-[#1a3bb8] transition-all shadow-sm flex items-center space-x-2" data-id="element-1135" data-mp="1gjuw1p47oc4m">
                        <span data-id="element-1136" data-mp="2rzjimfdjz94w">Get Started</span>
                        <ArrowRightIcon size={18} data-id="element-1137" data-mp="2n2jl4surrepe" />
                      </button>
                      {/* Purple-accented secondary */}
                      <button className="bg-white border-2 border-gray-200 text-[#1a0647] px-7 py-3.5 rounded-lg font-semibold hover:border-[#631bb7] hover:text-[#631bb7] transition-all" data-id="element-1138" data-mp="2viikgrimc9cz">
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* 2. Button Hierarchy */}
              <div data-id="element-1139" data-mp="3eaup5kwqvmqa">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1140" data-mp="3eabg6tp2o8oe">
                  2. Button Hierarchy
                </h3>
                <div className="bg-white rounded-xl p-8 border border-gray-200 flex flex-wrap items-center gap-6" data-id="element-1141" data-mp="34ki7q1k889od">
                  {/* Blue = primary */}
                  <button className="bg-[#214ae9] text-white px-6 py-2.5 rounded-md font-medium hover:bg-[#1a3bb8] transition-colors shadow-sm" data-id="element-1142" data-mp="39h07en0p9htu">
                    Primary Action
                  </button>
                  {/* Purple = accent / secondary */}
                  <button className="bg-white border border-[#631bb7] text-[#631bb7] px-6 py-2.5 rounded-md font-medium hover:bg-[#631bb7] hover:bg-opacity-5 transition-colors" data-id="element-1143" data-mp="foxd5br00ugq">
                    Secondary Outline
                  </button>
                  <button className="text-[#631bb7] px-4 py-2.5 rounded-md font-medium hover:bg-[#631bb7] hover:bg-opacity-5 transition-colors" data-id="element-1144" data-mp="5tvjq3pox68c">
                    Ghost Accent
                  </button>
                  <div className="h-8 w-px bg-gray-200 mx-2" data-id="element-1145" data-mp="3sybjuwgolvmf"></div>
                  {/* Soft purple pill for tertiary emphasis (replaces cyan) */}
                  <button className="bg-[#631bb7] bg-opacity-[0.08] text-[#631bb7] px-5 py-2 rounded-full text-sm font-semibold hover:bg-opacity-[0.14] transition-colors" data-id="element-1146" data-mp="3j7qkv7x3ip2z">
                    Accent Pill
                  </button>
                </div>
              </div>

              {/* 3. Feature Cards */}
              <div data-id="element-1147" data-mp="3588rsgcropnt">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1148" data-mp="357pitp53hblx">
                  3. Interactive Cards
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1149" data-mp="1pn6r6pgc15nw">
                  {/* Blue-led card */}
                  <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#214ae9] hover:shadow-md transition-all cursor-pointer group" data-id="element-1150" data-mp="1tqv3flfwspfh">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-[0.06] rounded-xl flex items-center justify-center mb-5 group-hover:bg-opacity-10 transition-all" data-id="element-1151" data-mp="11ynl8gkr94yz">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-1152" data-mp="15xwfdmjpj4v2" />
                    </div>
                    <h4 className="text-lg font-semibold text-[#1a0647] mb-2" data-id="element-1153" data-mp="1awz94au8lonq">
                      Bank-Level Security
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1154" data-mp="iay2szypkh2f">
                      Enterprise-grade protection scaled for your family's
                      everyday needs.
                    </p>
                  </div>
                  {/* Purple-accent card */}
                  <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#631bb7] hover:shadow-md transition-all cursor-pointer group" data-id="element-1155" data-mp="37sgh4fz252p1">
                    <div className="w-12 h-12 bg-[#631bb7] bg-opacity-[0.06] rounded-xl flex items-center justify-center mb-5 group-hover:bg-opacity-10 transition-all" data-id="element-1156" data-mp="3ltstkhf0em66">
                      <LockIcon className="w-6 h-6 text-[#631bb7]" data-id="element-1157" data-mp="3vpnks0xatpkk" />
                    </div>
                    <h4 className="text-lg font-semibold text-[#1a0647] mb-2" data-id="element-1158" data-mp="3qs44ywkyd4qi">
                      Privacy First
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1159" data-mp="9a1cdnfpfrty">
                      Your data stays yours. We never sell or share your
                      personal information.
                    </p>
                  </div>
                  {/* Blue-led card */}
                  <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#214ae9] hover:shadow-md transition-all cursor-pointer group" data-id="element-1160" data-mp="ddqz07ctjzcc">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-[0.06] rounded-xl flex items-center justify-center mb-5 group-hover:bg-opacity-10 transition-all" data-id="element-1161" data-mp="11x2ikvrkozjp">
                      <UserIcon className="w-6 h-6 text-[#214ae9]" data-id="element-1162" data-mp="nzm89965olmo" />
                    </div>
                    <h4 className="text-lg font-semibold text-[#1a0647] mb-2" data-id="element-1163" data-mp="rxbp8xer0ql7">
                      Family Managed
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1164" data-mp="iyykcwd84kwo">
                      One dashboard to monitor and protect everyone you care
                      about.
                    </p>
                  </div>
                </div>
              </div>

              {/* 4. Soft Surface (purple accent fill) */}
              <div data-id="element-1165" data-mp="3rfbbs7ysfki9">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1166" data-mp="3rf1st4c5udm2">
                  4. Soft Section Fill
                </h3>
                <div className="bg-[#631bb7] bg-opacity-[0.04] rounded-2xl p-10 border border-[#631bb7] border-opacity-10 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-1167" data-mp="r8xnnp8dwgza">
                  <div data-id="element-1168" data-mp="hjml6lg06akd">
                    <h4 className="text-2xl font-bold text-[#1a0647] mb-3" data-id="element-1169" data-mp="hibg8iatmwro">
                      Ready to secure your family?
                    </h4>
                    <p className="text-gray-600 max-w-md" data-id="element-1170" data-mp="mg4kh5skdgpb">
                      Join thousands of families who sleep better knowing their
                      digital lives are protected by Caveo.
                    </p>
                  </div>
                  {/* Blue primary CTA inside a purple-tinted zone */}
                  <button className="bg-[#214ae9] text-white px-7 py-3.5 rounded-lg font-semibold hover:bg-[#1a3bb8] transition-all shadow-sm flex items-center gap-2 whitespace-nowrap" data-id="element-1171" data-mp="3jbov2vxc3rt">
                    View pricing plans <ChevronRightIcon size={18} data-id="element-1172" data-mp="1xy5z521do4gd" />
                  </button>
                </div>
              </div>

              {/* 5. Usage Legend */}
              <div data-id="element-1173" data-mp="281t5imoikhyc">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1174" data-mp="232ggpwe310t4">
                  5. Role of Each Color
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1175" data-mp="2gvfunty7umyk">
                  {/* Blue = primary */}
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-1176" data-mp="2c1v6suqc79d3">
                    <h4 className="font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-1177" data-mp="2qqhimmgr9izk">
                      <div className="w-4 h-4 rounded-full bg-[#214ae9]" data-id="element-1178" data-mp="2ls6comtkzsmm"></div>
                      Blue — Primary
                    </h4>
                    <ul className="space-y-3 text-sm text-gray-600" data-id="element-1179" data-mp="2vr5lc5ecjo9m">
                      <li className="flex items-start gap-2" data-id="element-1180" data-mp="2vrx58iykzxk2">
                        <div className="w-4 h-4 rounded-full bg-[#214ae9] shrink-0 mt-0.5" data-id="element-1181" data-mp="15dy11nacn3pr"></div>
                        <span data-id="element-1182" data-mp="11dw8c3mldkmm">
                          <strong data-id="element-1183" data-mp="11ep6whbed3to">Primary Actions:</strong> Main CTAs and key
                          buttons stay blue
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1184" data-mp="35i0gwo02pmfn">
                        <div className="w-4 h-4 rounded-full bg-[#214ae9] bg-opacity-[0.08] border border-[#214ae9] shrink-0 mt-0.5" data-id="element-1185" data-mp="3ag23vk0me5we"></div>
                        <span data-id="element-1186" data-mp="3fg6mbfl39ap9">
                          <strong data-id="element-1187" data-mp="3fd26tm26asja">Trust Signals:</strong> Security icons and
                          headline emphasis
                        </span>
                      </li>
                    </ul>
                  </div>
                  {/* Purple = accent */}
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-1188" data-mp="3t7l3rhzcl3u7">
                    <h4 className="font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-1189" data-mp="20icyrnf8zki">
                      <div className="w-4 h-4 rounded-full bg-[#631bb7]" data-id="element-1190" data-mp="704omwnlq7r7"></div>
                      Purple — Accent
                    </h4>
                    <ul className="space-y-3 text-sm text-gray-600" data-id="element-1191" data-mp="b16qzmctezxe">
                      <li className="flex items-start gap-2" data-id="element-1192" data-mp="1vk0qir8bb6b0">
                        <div className="w-4 h-4 rounded-full bg-[#631bb7] bg-opacity-[0.08] border border-[#631bb7] shrink-0 mt-0.5" data-id="element-1193" data-mp="1rhdwcjo659an"></div>
                        <span data-id="element-1194" data-mp="1mjcbpub3h1x2">
                          <strong data-id="element-1195" data-mp="1mkdoq4bo7yhf">Badges & Pills:</strong> Feature flags and
                          tertiary emphasis
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1196" data-mp="2f5nenbm6bex1">
                        <div className="w-4 h-4 rounded-full bg-[#631bb7] bg-opacity-10 shrink-0 mt-0.5" data-id="element-1197" data-mp="2a7c2gu8eosbn"></div>
                        <span data-id="element-1198" data-mp="25gdkzrbolo6t">
                          <strong data-id="element-1199" data-mp="25fkmfdmvm4zr">Soft Fills & Hovers:</strong> Section tints,
                          secondary card accents
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1200" data-mp="2xy822dj3srtg">
                        <div className="w-4 h-4 rounded-full border-2 border-[#631bb7] shrink-0 mt-0.5" data-id="element-1201" data-mp="2t6zqpby7qwdn"></div>
                        <span data-id="element-1202" data-mp="2do6umzw6gj57">
                          <strong data-id="element-1203" data-mp="2dnx152bxbtur">Secondary Buttons:</strong> Outline / ghost
                          styles, not main actions
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <p className="text-xs text-gray-400 mt-4" data-id="element-1204" data-mp="28pdh57gw4s51">
                  Cyan is fully retired in this direction — purple covers every
                  accent role.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}